import { PageHero } from "@/components/sections";

// Renders a legal document: sections with heading, paragraphs and optional list
const LegalPage = ({ title, subtitle, updated, sections, testid }) => (
  <>
    <PageHero eyebrow="Informazioni legali" title={title} subtitle={subtitle} />
    <section className="py-16 lg:py-24 bg-white" data-testid={testid}>
      <div className="container-x max-w-3xl">
        {updated && <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {updated}</p>}
        <div className="mt-8 space-y-10">
          {sections.map((s, i) => (
            <div key={i}>
              {s.h && <h2 className="font-serif text-2xl font-bold text-navy">{s.h}</h2>}
              {(s.p || []).map((para, j) => (
                <p key={j} className="mt-3 text-muted-foreground leading-relaxed">{para}</p>
              ))}
              {s.list && (
                <ul className="mt-4 space-y-2">
                  {s.list.map((li, k) => (
                    <li key={k} className="flex gap-3 text-muted-foreground leading-relaxed">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-green" />
                      <span>{li}</span>
                    </li>
                  ))}
                </ul>
              )}
              {s.table && (
                <div className="mt-6" data-testid={`${testid}-table-${i}`}>
                  {/* Desktop: tabella completa */}
                  <div className="hidden overflow-hidden rounded-xl border border-gray-200 md:block">
                    <table className="w-full border-collapse text-left text-sm">
                      <thead className="bg-gray-50">
                        <tr>
                          {s.table.headers.map((h, hi) => (
                            <th key={hi} className="border-b border-gray-200 px-4 py-3 align-top font-semibold text-navy">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {s.table.rows.map((row, ri) => (
                          <tr key={ri} className="align-top">
                            {row.map((cell, ci) => (
                              <td key={ci} className="border-b border-gray-100 px-4 py-3 leading-relaxed text-muted-foreground">{cell}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Mobile: righe impilate come schede, nessun testo tagliato */}
                  <div className="space-y-4 md:hidden">
                    {s.table.rows.map((row, ri) => (
                      <div key={ri} className="rounded-xl border border-gray-200 p-4">
                        {row.map((cell, ci) => (
                          <div key={ci} className={ci > 0 ? "mt-3 border-t border-gray-100 pt-3" : ""}>
                            <div className="text-xs font-semibold uppercase tracking-wide text-navy">{s.table.headers[ci]}</div>
                            <div className="mt-1 text-sm leading-relaxed text-muted-foreground">{cell}</div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default LegalPage;
